import React from 'react';
import style from './Products.module.css';
import { useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();
  return (
    <div className={style.home}>
      <div className={style.section}>
        <div className={style.navigation}>
          <button className={`${style.list} btn btn-default`} onClick={navigate.bind(null, '/CarsList')}>
            Baza Pojazdów
          </button>
          <button className={`${style.list} btn btn-default`} onClick={navigate.bind(null, '/ClientsList')}>
            Baza Klientów
          </button>
        </div>
        <div className={style.navigation}>
          <button className={`${style.cars} btn btn-default`} onClick={navigate.bind(null, '/DriversList')}>
            Baza kierowców
          </button>
          <button className={`${style.cars} btn btn-default`} onClick={navigate.bind(null, '/UserList')}>
            Zarządzanie użytkownikami
          </button>
        </div>
      </div>
    </div>
  );
}
